import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { isFullArray } from '@shared/lib/array'
import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface UploadCvReturn {
  mode: ComputedRef<InputMode>
  cv: ComputedRef<File | File[] | null>
  setDeleteDraftFile: () => void
  setDroppedCv: (acceptFiles: File[] | File | null) => void
}

export const useUploadCv = (): UploadCvReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const mode = computed(() => getMode(tutorApplicationStore.getShowErrors && !tutorApplicationStore.cv))
  const cv = computed(() => tutorApplicationStore.cv)

  const setDroppedCv = (acceptFiles: File[] | File | null): void => {
    if (!isFullArray(acceptFiles)) {
      tutorApplicationStore.setCv(acceptFiles)
    }
  }

  const setDeleteDraftFile = (): void => {
    tutorApplicationStore.setCv(null)
  }
  
  return {
    mode,
    cv,
    setDeleteDraftFile,
    setDroppedCv,
  }
}
